import {Component, Input} from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';
import {ProductCreateWfoodcostInfoPage} from "../../product-create/product-create-without-foodcost/product-create-wfoodcost-info/product-create-wfoodcost-info";
import {ProductCreateFoodcostInfoPage} from "../../product-create/product-create-foodcost/product-create-foodcost-info/product-create-foodcost-info";

/**
 * Generated class for the ProductViewTagsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-product-view-tags',
    templateUrl: 'product-view-tags.html',
})
export class ProductViewTagsPage {
    @Input() product: any;
    tags: any = [];

    constructor(public navCtrl: NavController,
                public navParams: NavParams) {

        //this.tags = this.dish.tags;
    }

    edit() {
        if (this.product.sub_recipe == false) {
            this.navCtrl.push(ProductCreateWfoodcostInfoPage, {
                update_state: true,
                product_uid: this.product.UID,
                product_name: this.product.name,
                measurement: this.product.measurement,
                stock: this.product.stock,
                stock_alert: this.product.stock_alert,
                tags: this.product.tags,
                pvp: this.product.pvp,
                name_en: this.product.name_en,
                name_fr: this.product.name_fr,
                name_it: this.product.name_it,
                name_de: this.product.name_de,
                name_ca: this.product.name_ca,
                description_es: this.product.description_es,
                description_en: this.product.description_en,
                description_fr: this.product.description_fr,
                description_it: this.product.description_it,
                description_de: this.product.description_de,
                description_ca: this.product.description_ca,
                product: this.product,
            })
        } else {
            this.navCtrl.push(ProductCreateFoodcostInfoPage, {
                update_state: true,
                product_uid: this.product.UID,
                product_name: this.product.name,
                measurement: this.product.measurement,
                stock: this.product.stock,
                stock_alert: this.product.stock_alert,
                tags: this.product.tags,
                pvp: this.product.pvp,
                name_en: this.product.name_en,
                name_fr: this.product.name_fr,
                name_it: this.product.name_it,
                name_de: this.product.name_de,
                name_ca: this.product.name_ca,
                description_es: this.product.description_es,
                description_en: this.product.description_en,
                description_fr: this.product.description_fr,
                description_it: this.product.description_it,
                description_de: this.product.description_de,
                description_ca: this.product.description_ca,
                product: this.product,
            })
        }
    }


}



// WEBPACK FOOTER //
// ./src/pages/products/product-view/product-view-tags/product-view-tags.ts